import { render, staticRenderFns } from "./quickSell.vue?vue&type=template&id=b22fe582&scoped=true"
import script from "./quickSell.vue?vue&type=script&lang=js"
export * from "./quickSell.vue?vue&type=script&lang=js"
import style0 from "./quickSell.vue?vue&type=style&index=0&id=b22fe582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22fe582",
  null
  
)

export default component.exports